export interface OpeningHoursItemProps {
  day: string
  openTime: string | null
  closeTime: string | null
  isClosed: boolean
  bg?: string
  text?: string
  hoursBg?: string
  hoursText?: string
}

export const useOpeningHoursItem = (props: OpeningHoursItemProps) => {
  return {
    ...props,
  }
}
